var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg016Startup = function Svg016Startup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M489.067 63.479c.943-.149 1.88-.255 2.813-.337 2.226-25.389-20.132-46.704-45.792-42.641-59.725 9.456-159.888 35.636-232.086 107.834-42.098 42.098-68.447 93.659-85.062 141.212l42.979 42.979c16.614-47.554 42.963-99.114 85.062-141.212 72.198-72.199 172.361-98.38 232.086-107.835z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.15 439.461C113.529 455.082 20.042 492 20.042 492s36.919-93.487 52.54-109.107 40.948-15.621 56.569 0 15.62 40.947-.001 56.568z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.087 216.361c28.692-54.352 42.1-110.587 48.349-149.733 4.291-26.885-18.467-50.384-45.357-46.126-59.726 9.457-159.882 35.639-232.076 107.833-42.098 42.098-68.447 93.659-85.062 141.212l113.555 113.555c47.554-16.614 99.114-42.963 141.212-85.062 6.266 44.09-2.183 89.86-25.369 129.384-13.334 22.73-44.596 26.923-63.23 8.29l-52.613-52.612",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.941 269.546-52.613-52.613c-18.634-18.634-14.441-49.898 8.289-63.231 39.525-23.185 85.306-31.645 129.396-25.379",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.14,
    cy: 184.903,
    r: 40,
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.151 43.208 113.683 113.684",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }));
};

export default Svg016Startup;